export const ESG_ENDPOINTS = {
  FRAMEWORKS: "/frameworks",
  DISCLOSURES: "/disclosures",
  QUANT_TARGETS: "/quantitative-targets",
  QUANT_TARGETS_BULK: "/quantitative-targets/bulk",
  QUANT_TARGETS_SEED: "/quantitative-targets/seed",
  CARBON_TARGETS: "/targets",

  ESG_REPORTS: (id) => `/esg-reports${id ? `/${id}` : ""}`,
  ESG_REPORT_DUPlICATE: (id) => `/esg-reports/${id}/duplicate`,
  ESG_REPORT_FILES: (reportId, fileId) =>
    `/esg-reports/${reportId}/files${fileId ? `/${fileId}` : ""}`,
  ESG_REPORT_DELEGATE: (id) => `/esg-reports/${id}/delegate`,
  ESG_REPORT_PREFILL: "/esg-reports/prefill-suggestions",
  METRIC_MAPPINGS: "/metric-mappings",
};
